(function() { module.exports = window["wp"]["apiFetch"]; }());